module.exports = __webpack_public_path__ + "738a12d591d02a212810b171b25e14b0.MP3";